"use client";

import type { ReactNode } from "react";

import { DevTraceDock } from "@/features/dev-trace/DevTraceDock";
import { isSessionTracesEnabled } from "@/features/dev-trace/session-traces-enabled";
import { AuthProvider } from "@/shared/auth";
import { SnackbarProvider } from "@/shared/lib/notifications/SnackbarProvider";
import { QueryProvider } from "@/shared/lib/providers/QueryProvider";
import { TooltipProvider } from "@/shared/ui/shadcn-components/tooltip";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <SnackbarProvider>
      <QueryProvider>
        <TooltipProvider delayDuration={700} skipDelayDuration={0}>
          <AuthProvider>
            {children}
            {isSessionTracesEnabled() ? <DevTraceDock /> : null}
          </AuthProvider>
        </TooltipProvider>
      </QueryProvider>
    </SnackbarProvider>
  );
}
